<div class="request-table-container">
  <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort (matSortChange)="onSortChanged($event)" class="mat-elevation-z1 full-width plain-table">

    <!-- Expand toggle -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button type="button" (click)="toggleRow(row); $event.stopPropagation()" [disabled]="!row.subRequestCount">
          <mat-icon>{{ expandedElement === row ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('id'), integerOnly: true }">
          {{ 'dataManagement.dataExchangeRequests.columns.id' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.id }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('name') }">
          {{ 'dataManagement.dataExchangeRequests.columns.name' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('name'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>

    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()">
          {{ 'dataManagement.dataExchangeRequests.columns.createdAt' | transloco }}
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ getDate(row.createdAt) | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('status'), categories: getStatusOptions() }">
          {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
          <mat-icon class="filter-icon" *ngIf="isStatusFilterCustomized()">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ getStatusLabel(row.status) | transloco }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="!isReceived">
          <button mat-icon-button type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.withdraw' | transloco"
            [disabled]="row.status === requestStatus.Deleted"
            (click)="onWithdrawRequest(row); $event.stopPropagation()">
            <mat-icon>undo</mat-icon>
          </button>
          <button mat-icon-button type="button"
            [title]="'dataManagement.dataExchangeRequests.actions.approve' | transloco"
            [disabled]="!allSubRequestsSubmitted(row)"
            (click)="onApproveRequest(row); $event.stopPropagation()">
            <mat-icon>done_all</mat-icon>
          </button>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="counterpart">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('counterpart') }">
          {{ (isReceived ? 'dataManagement.dataExchangeRequests.columns.sender' : 'dataManagement.dataExchangeRequests.columns.recipient') | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('counterpart'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ isReceived ? row.sendingSecurityPrincipal?.name : row.receivingSecurityPrincipal?.name }}</td>
    </ng-container>

    <ng-container matColumnDef="subRequestCount">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <button mat-button class="filter-button" type="button"
          (click)="$event.stopPropagation()"
          [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('subRequestCount') }">
          {{ 'dataManagement.dataExchangeRequests.columns.items' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestCount'))">filter_alt</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.subRequestCount ?? 0 }}</td>
    </ng-container>

    <!-- Expandable detail row -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns.length">
        <div class="detail-container"
          [@detailExpand]="row === expandedElement ? 'expanded' : 'collapsed'">
          <ng-container *ngIf="row === expandedElement">
            <app-data-exchange-sub-request-table
              [dataSource]="getSubRequestDataSource(row)"
              [dataExchangeRequestId]="row.id"
              [isReceived]="isReceived"
              (navigateToSubRequest)="onNavigateSubRequest($event)"
              (approveSubRequest)="onApproveSubRequest($event)"
              (reopenSubRequest)="onReopenSubRequest($event)"
              (withdrawSubRequest)="onWithdrawSubRequest($event)"
              (showSubRequestComments)="onShowSubRequestComments($event)">
            </app-data-exchange-sub-request-table>
          </ng-container>

          <!-- Comments -->
          <div class="comments-section">
            <h4 class="comments-title">{{ 'dataManagement.dataExchangeRequests.comments.title' | transloco }}</h4>
            <app-data-exchange-comments
              [comments]="row.comments"
              (commentAdded)="onCommentAdded($event, row)">
            </app-data-exchange-comments>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      class="request-row"
      [class.expanded-row]="expandedElement === row"
      [class.notificationBackground]="isReceived ? row.hasNotificationForReceiver : row.hasNotificationForSender"
      (click)="toggleRow(row)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        {{ 'dataManagement.dataExchangeRequests.noData' | transloco }}
      </td>
    </tr>
  </table>

  <div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
  </div>

  <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
</div>

<mat-paginator class="request-paginator" [length]="1" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page" (page)="onPageChanged($event)"></mat-paginator>
